module.exports = __webpack_public_path__ + "static/media/archive.6d7e8260.svg";